import { InjectionToken } from '@angular/core'
import { AuthService } from '../service/auth.service'
import { AppConfigModel } from '../models/app-config.model'

export const AUTH_SERVICE = new InjectionToken<AuthService>('auth.service')
export const APP_CONFIG = new InjectionToken<AppConfigModel>('app.config')
